import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

interface Props {
  sx?: SxProps
  [props: string]: any
}

export const BlogWappIcon = ({ sx, ...props }: Props) => (
  <SvgIcon
    viewBox="0 0 24 24"
    sx={{ width: '24px', height: '24px', ...sx }}
    {...props}
  >
    <path
      d="M20 22H4C3.73478 22 3.48043 21.8946 3.29289 21.7071C3.10536 21.5196 3 21.2652 3 21V3C3 2.73478 3.10536 2.48043 3.29289 2.29289C3.48043 2.10536 3.73478 2 4 2H20C20.2652 2 20.5196 2.10536 20.7071 2.29289C20.8946 2.48043 21 2.73478 21 3V21C21 21.2652 20.8946 21.5196 20.7071 21.7071C20.5196 21.8946 20.2652 22 20 22ZM19 20V4H5V20H19ZM7 6H11V10H7V6ZM7 12H17V14H7V12ZM7 16H17V18H7V16ZM13 7H17V9H13V7Z"
      fill="url(#BlogWappIcon)"
    />
    <defs>
      <linearGradient
        id="BlogWappIcon"
        x1="4.20577"
        y1="17"
        x2="20.5716"
        y2="8.49606"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F57073" />
        <stop offset="1" stopColor="#FA4545" />
      </linearGradient>
    </defs>
  </SvgIcon>
)

BlogWappIcon.defaultProps = {
  sx: null,
}
